import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { Utils } from "../../utils";
import { RNSAPI } from "../../api";
import { Postbox } from '../postbox/postbox';
import './dialog';
import './message';
import Navigo = require("navigo");
import './deadlineDialog';
import '../dialog/editAppointmentDialog';
export class stackDialogViewModel {
    givenId = "NewStackDialogExt";
    viewWithoutModal = ko.observable(false);
    showErrorOfInstances = ko.observable(false);
    showStack = ko.observable(false);
    caseId = ko.observable("");
    rubrum = ko.observable("ABC");
    instance = ko.observable(null);
    instanceInCase = ko.observableArray([]);
    instanceIdFromParameter = ko.observable(0);
    state = ko.observable("");
    referenceDate = ko.observable(moment().format("YYYY-MM-DD"));
    formatedReferenceDate = ko.observable("");
    sbId = ko.observable("");
    mailid = ko.observable(null);
    currentAttachmentId = ko.observable(0);
    isOutbox = ko.observable(false);
    allStacks = ko.observableArray([]);
    allAutomationTasks = ko.observableArray([]);
    currentStack = ko.observable(null);
    currentStackId = ko.observable(null);
    showFinished = ko.observable(false);
    async getRubrumFromCase() {
        if (ko.toJS(this.caseId) !== "") {
            let resCase = (await RNSAPI.getExtendedCase(ko.toJS(this.caseId))).Payload;
            let res = resCase.Akte;
            this.rubrum(res.Rubrum);
            this.instanceInCase(resCase.Instances);
            if (resCase.Instances.length > 0) {
                this.instance(resCase.Instances[resCase.Instances.length - 1]);
                if (ko.toJS(this.instanceIdFromParameter)) {
                    let ins = ko.toJS(this.instanceInCase);
                    ins = ins.filter(f => f.InstanceId === ko.toJS(this.instanceIdFromParameter));
                    this.instance(ins[0]);
                }
                this.showErrorOfInstances(false);
            }
            else
                this.showErrorOfInstances(true);
        }
    }
    async beginStack() {
        this.formatedReferenceDate(moment(ko.toJS(this.referenceDate)).format("DD.MM.yyyy"));
        await RNSAPI.getMakroById(this.currentStackId(), ko.toJS(this.referenceDate), ko.toJS(this.instance).InstanceId).then((data) => {
            let makro = data as any;
            this.currentStack(this.mapMakros(makro, ko.toJS(this.currentStack().note())));
        }).catch((error) => {
            console.log(error);
        });
        this.showStack(true);
    }
    endStack() {
        this.showFinished(false);
        this.showStack(false);
    }
    collapseLogic(index: number) {
        if (ko.toJS(this.currentStack().entrys()[ko.toJS(index)].display) === null) {
            if (ko.toJS(index) === 0)
                this.currentStack().entrys()[ko.toJS(index)].display(true);
            else
                this.currentStack().entrys()[ko.toJS(index)].display(false);
        }
        else {
            for (let i = 0; i < ko.toJS(this.currentStack().entrys()).length; i++) {
                let display = false;
                if (i === ko.toJS(index) && ko.toJS(this.currentStack().entrys()[ko.toJS(index)].display) === false)
                    display = true;
                this.currentStack().entrys()[i].display(ko.toJS(display));
            }
        }
    }
    remove(index: number) {
        if (ko.toJS(this.currentStack().entrys()[ko.toJS(index)].removed) === null) {
            this.currentStack().entrys()[ko.toJS(index)].removed(false);
            this.currentStack().entrys()[ko.toJS(index)].reactivated(null);
        }
        else {
            this.currentStack().entrys()[ko.toJS(index)].display(false);
            this.currentStack().entrys()[ko.toJS(index)].reactivated(null);
            this.currentStack().entrys()[ko.toJS(index)].removed(true);
            this.checkFinished();
        }
    }
    reactivate(index: number) {
        if (ko.toJS(this.currentStack().entrys()[ko.toJS(index)].reactivated) === null) {
            this.currentStack().entrys()[ko.toJS(index)].reactivated(false);
            this.currentStack().entrys()[ko.toJS(index)].removed(true);
        }
        else {
            this.currentStack().entrys()[ko.toJS(index)].reactivated(false);
            this.currentStack().entrys()[ko.toJS(index)].removed(null);
            this.currentStack().entrys()[ko.toJS(index)].display(true);
            this.checkFinished();
        }
    }
    closeModal() {
        if (ko.toJS(this.mailid) === null) {
            if (ko.toJS(this.showStack) === false)
                $("#NewStackDialogExt").modal("hide");
            else {
                if (ko.toJS(this.checkToClose())) {
                    this.endStack();
                    $("#NewStackDialogExt").modal("hide");
                }
                else
                    alert("Die Bearbeitung der Fristenassistenz ist noch nicht vollständig abgeschlossen. Bitte tragen Sie die vorgegebenen Fristen/Termine ein, oder entfernen sie diese.");
            }
        }
        else {
            this.endStack();
            if (ko.toJS(this.isOutbox))
                Postbox.publisher().publish("", "ShowFTAfterMakroEntryOutbox");
            else
                Postbox.publisher().publish("", "ShowFTAfterMakroEntry");
        }
    }
    checkToClose() {
        if (ko.toJS(this.currentStack().entrys().filter(d => ko.toJS(d.saved) === false && ko.toJS(d.removed) === false).length) !== 0) {
            return false;
        }
        return true;
    }
    mapMakros(makro, note = "") {
        let obj = {
            id: makro.ID,
            title: ko.observable(makro.Name),
            comment: ko.observable(makro.Comment),
            note: ko.observable(note != "" ? note : makro.NoteSuggestion),
            entrys: this.mapMakroItems(makro.Items)
        };
        return obj;
    }
    mapMakroItems(items) {
        let entrys = ko.observableArray([]);
        for (let item of items) {
            let obj = {
                id: ko.observable(0),
                isDeadline: ko.observable(item.IsDeadline),
                typeId: ko.observable(item.TypeId),
                typeName: ko.observable(item.TypeName),
                calculatedDates: ko.observable(item.CalculatedDates),
                calculationLogic: ko.observable(item.CalculationString),
                saved: ko.observable(false),
                display: ko.observable(null),
                removed: ko.observable(null),
                reactivated: ko.observable(null),
                formatedDate: ko.observable("")
            };
            entrys.push(obj);
        }
        return entrys;
    }
    async getStacks() {
        await RNSAPI.getMakros(false).then((data) => {
            this.allStacks([]);
            let makros = data as any;
            this.allStacks(makros.map((makro) => {
                return this.mapMakros(makro);
            }));
            if (ko.toJS(this.allStacks).length > 0)
                this.currentStackId(this.allStacks()[0].id);
        }).catch((error) => {
            console.log(error);
            this.allStacks([]);
        });
    }
    mapTasks(task) {
        let obj = {
            id: task.ID,
            title: ko.observable(task.Name),
            note: ko.observable(task.Note)
        };
        return obj;
    }

    async getAllAutomations() {
        await RNSAPI.getAutomationTasks().then((data) => {
            let tasks = data as any;
            this.allAutomationTasks([]);
            this.allAutomationTasks(tasks.map((task) => {
                return this.mapTasks(task);
            }));
        }).catch((error) => {
            console.log(error);
            this.allAutomationTasks([]);
        });
    }
    async getDefaultSachbearbeiter() {
        let sach = RNSAPI.User().username;
        this.sbId(sach);
    }
    setCompletion(createdEntry) {
        try {
            if (ko.toJS(this.currentStack().entrys()).length > 0) {
                this.currentStack().entrys()[ko.toJS(createdEntry.index)].id(ko.toJS(createdEntry.id));
                this.currentStack().entrys()[ko.toJS(createdEntry.index)].saved(true);
                this.currentStack().entrys()[ko.toJS(createdEntry.index)].formatedDate(ko.toJS(createdEntry.dateOfEntry));
                this.currentStack().entrys()[ko.toJS(createdEntry.index)].display(false);
                if (this.currentStack().entrys().length > ko.toJS(createdEntry.index) + 1)
                    this.currentStack().entrys()[ko.toJS(createdEntry.index) + 1].display(true);
                this.checkFinished();
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    checkFinished() {
        if (this.checkToClose())
            this.showFinished(true);
        else
            this.showFinished(false);
    }
    constructor(params: any) {
        if (params.Case) {
            this.caseId(ko.toJS(params.Case));
            if (params.InstanceId)
                this.instanceIdFromParameter(ko.toJS(params.InstanceId));
            if (params.MailMessageId)
                this.mailid(ko.toJS(params.MailMessageId));
            if (params.AttachmentId)
                this.currentAttachmentId(ko.toJS(params.AttachmentId));
            this.getRubrumFromCase();
        }
        if (params.showWithoutModal)
            this.viewWithoutModal(params.showWithoutModal);
        if (params.isOutbox)
            this.isOutbox(params.isOutbox);
        this.getDefaultSachbearbeiter();
        this.getStacks();
        this.getAllAutomations();
        this.currentStackId.subscribe(() => {
            let currentStack = this.allStacks().filter(a => ko.toJS(a.id) === ko.toJS(this.currentStackId));
            if (currentStack.length === 1)
                this.currentStack(currentStack[0]);
        });
        Postbox.publisher().subscribe((createdEntry) => {
            this.setCompletion(createdEntry);
        }, "CreatedEntryInStack");
    }
}
let html = fs.readFileSync(__dirname + "/stackDialog.html", "utf8");
ko.components.register("stack-dialog-view", {
    viewModel: stackDialogViewModel,
    template: html,
});
